import ErrorHandlingForm from "../../../components/formValidation/ErrorHandlingFrom";
import {FormControl, FormControlLabel, InputLabel, MenuItem, Stack, Switch} from "@mui/material";
import CustomSelect from "../../../components/formValidation/CustomSelect";
import {deliveryFormats, deliveryPeriods, deliveryTypes} from "../../../utils/enums";
import React, {useEffect, useState} from "react";
import useDataModel from "../../../hooks/dataModel";
import useCallDataApi from "../../../hooks/data";
import CustomDatePicker from "../../../components/formValidation/CustomDatePicker";
import CustomTimePicker from "../../../components/formValidation/CustomTimePicker";
import {
    validateMaxDateDiff,
    validateRequired,
    validateRequiredIf,
    validateTime
} from "../../../components/formValidation/validators";
import CustomAddressPicker from "../../../components/formValidation/CustomAddressPicker";
import CustomSwitch from "../../../components/formValidation/CustomSwitch";
import CustomTextField from "../../../components/formValidation/CustomTextField";

const ReturnData = ({data, setData, reference}) => {
    const [onlyHungary, setOnlyHungary] = useState(true)
    const {fetchModel: fetchCouriers, models: couriers, setModels} = useDataModel(useCallDataApi('users'))
    useEffect(() => fetchCouriers('get_couriers', models => setModels(models)), []);
    const [errors, setErrors] = useState({
        return_type: false,
        return_courier_new: false,
        return_address: false,
        return_time: false,
        return_period: false,
        actual_return_date: false,
        return_time_set: false,
        return_comment: false,
    });

    const validators = {
        return_type: [validateRequired],
        return_courier_new: [],
        return_address: [value => validateRequiredIf(value?.address_com, data?.return_type !== deliveryTypes.TGS_OFFICE)],
        return_time: [validateTime],
        return_period: [],
        actual_return_date: [validateRequired, value => validateMaxDateDiff(10, value, data?.return_date)],
        return_time_set: [],
        return_comment: [],
    }

    const onAddressChange = (address) => {
        const country = address?.address?.country
        const postalCode = address?.address?.postal_code
        const hungarian = country === 'HU'
        const number = parseInt(postalCode)
        const inBudapest = 1000 <= number && number < 2000

        if (hungarian) {
            if (inBudapest) {
                setData(prev => ({...prev, return_type: deliveryTypes.HAND}))
            } else {
                setData(prev => ({...prev, return_type: deliveryTypes.GLS}))
            }
        } else {
            setData(prev => ({...prev, return_type: deliveryTypes.DHL}))
        }
    }

    const onDeliveryMethodChange = method => {
        if ([deliveryTypes.GLS, deliveryTypes.DHL].includes(method)) {
            setData(prev => ({...prev, delivery_format: deliveryFormats.Case}))
        } else setData(prev => ({...prev, delivery_format: deliveryFormats.Backpack}))
    }

    useEffect(() => {
        onDeliveryMethodChange(data?.return_type)
    }, [data?.return_type])

    return <ErrorHandlingForm
        data={data}
        setData={setData}
        errors={errors}
        setErrors={setErrors}
        validators={validators}
        reference={reference}
    >
        <Stack spacing={1}>
            <FormControl sx={{width: '100%'}}>
                <InputLabel id="return-types">Visszaszállítás módja</InputLabel>
                <CustomSelect
                    labelId="return-types"
                    label="Vissza szállítási mód"
                    name="return_type"
                    data={data}
                    setData={setData}
                    errors={errors}
                    setErrors={setErrors}
                    validators={validators}
                    sideEffect={deliveryType => onDeliveryMethodChange(deliveryType)}
                >
                    <MenuItem value=''>-</MenuItem>
                    {Object.entries(deliveryTypes).map(([key, value]) => <MenuItem key={key}
                                                                                   value={value}>{value}</MenuItem>)}
                </CustomSelect>
            </FormControl>

            {data?.return_type === deliveryTypes.HAND && <FormControl sx={{width: '100%'}}>
                <InputLabel id="return-courier">Visszaszállító futár</InputLabel>
                <CustomSelect
                    labelId="return-courier"
                    label="Visszaszállító futár"
                    name="return_courier_new"
                    data={data}
                    setData={setData}
                    errors={errors}
                    setErrors={setErrors}
                    validators={validators}
                >
                    <MenuItem value={null}>-</MenuItem>
                    {couriers.map(r => (
                        <MenuItem key={r.id} value={r.id}>{r.name}</MenuItem>
                    ))}
                </CustomSelect>
            </FormControl>}

            {data?.return_type !== deliveryTypes.TGS_OFFICE && <FormControlLabel
                control={<Switch checked={onlyHungary} onChange={() => setOnlyHungary(prev => !prev)}/>}
                label={onlyHungary ? "Csak magyar címek" : "Bármilyen cím"}
            />}

            {data?.return_type !== deliveryTypes.TGS_OFFICE && <CustomAddressPicker
                onlyHungary={onlyHungary}
                name='return_address'
                label="Visszavételi cím"
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
                onAddressChange={address => onAddressChange(address)}
            />}


            <CustomSwitch
                name='return_time_set'
                labelOn='Pontos időt adok meg'
                labelOff='Intervallumot adok meg'
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
            />

            {data?.return_time_set && <CustomTimePicker
                name='return_time'
                label="Visszaszállítási idő idő"
                sx={{width: '100%'}}
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
            />}

            {!data?.return_time_set && <FormControl sx={{width: '100%'}}>
                <InputLabel id="deivery_period_selector">Vissza mikor</InputLabel>
                <CustomSelect
                    labelId="deivery_period_selector"
                    label="Mikor"
                    name="return_period"
                    data={data}
                    setData={setData}
                    errors={errors}
                    setErrors={setErrors}
                    validators={validators}
                >
                    <MenuItem value=''>-</MenuItem>
                    {Object.entries(deliveryPeriods).map(([key, value]) => <MenuItem key={key}
                                                                                     value={value}>{value}</MenuItem>)}
                </CustomSelect>
            </FormControl>}


            <CustomDatePicker
                sx={{width: '100%'}}
                name="actual_return_date"
                label="Visszaszállítás dátuma"
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
                minDate={data?.return_date}
                inputFormat='yyyy-MM-dd'
            />

            <CustomTextField
                name='return_comment'
                label="Visszaszállítás komment"
                multiline={true}
                rows={4}
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
            />

        </Stack>
    </ErrorHandlingForm>
}

export default ReturnData